import React from 'react';

const EventsPage = () => {
  return (
    <div>
      <h1>Events Page</h1>
      <p>This is the Events page.</p>
    </div>
  );
};

export default EventsPage;
